<template>
	<div class="homeCon" @click="popupStatus=false">
		<div class="content" >
			
			<div class="topHead">
				<searchBox :type='1' place='搜索职位' @search='search' @openStatus='openStatus'></searchBox>
				<div v-show="popupStatus" class="popup">
					<classType :type='1'></classType>
				</div>
			</div>
			
			<div style="margin-bottom: 48px;">
				<classType :type='2'></classType>
			</div>
			
			<div class="bigTitle">
				热招职位
			</div>
			
			<div class="position">
				<position v-for="(item,index) of jobList" :key="index" class="lis" :type='1' :itemData='item'></position>
			</div>
			
			<div class="look" @click="look(1)">
				查看更多
			</div>
			
			<div class="bigTitle">
				热门企业
			</div>
			
			<div class="corporation">
				<div v-for="(item,index) of companyList" :key="index" class="corporationLi">
					<div class="corporInfo" @click="companyDe(item.id)">
						<el-image :src="item.logo||require('@/static/company.png')" fit="cover" class="logo"></el-image>
						<div class="right">
							<div class="name">
								{{item.company_name}}
							</div>
							<div class="num">
								{{item.person_count}}
							</div>
						</div>
					</div>
					<div>
						<no-Data v-if="item.position.length==0" top="50" text="暂无在招职位"></no-Data>
						<position v-if="i<3" v-for="(tab,i) of item.position" :key="i" class="lis" :itemData='tab' :type='2'></position>
					</div>
				</div>
			</div>
			
			<div class="look" @click="look(2)">
				查看更多
			</div>
			
		</div>
	</div>
</template>

<script>
	import classType from '@/components/classType.vue'
	import position from '@/components/position.vue'
	import searchBox from '@/components/searchBox.vue'
	export default {
		components:{
			classType,
			position,
			searchBox
		},
		data() {
			return {
				jobList:[],
				companyList:[],
				popupStatus: false, //弹出框的状态
			}
		},
		created() {
			this.getHotjob()
			this.getHotCompany()
		},
		methods: {
			openStatus(){
				this.popupStatus=!this.popupStatus
			},
			// 跳转到搜索
			search(value){
				if(value){
					this.$router.push({ name: 'Search', params: { name: value } });
				}else{
					this.$router.push({ name: 'Search' });
				}
			},
			// 热招职位
			getHotjob(){
				this.$axios.get('/api/client/Home/getHotPosition').then(res => {
					this.jobList=res.data
				})
			},
			// 热门公司
			getHotCompany(){
				this.$axios.get('/api/client/Home/getHotCompanyList').then(res => {
					this.companyList=res.data
				})
			},
			companyDe(id){
				this.$router.push({ name: 'companyDe',query: {id:id } });
			},
			look(type){
				if(type==1){
					this.$router.push({ name: 'Search'});
				}else{
					this.$router.push({ name: 'corporation'});
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.homeCon {
		position: relative;
		padding: 48px 0 0;
		display: flex;
		justify-content: center;
		box-sizing: border-box;
		.content {
			width: 1200px;
			position: relative;
			z-index: 2;
			
			.topHead{
				position: relative;
				z-index: 996;
				.popup {
					position: absolute;
					top: 70px;
					width: 896px;
					left: 85px;
				}
			}
			
		    .bigTitle{
				color: #151515;
				font-size: 36px;
				text-align: center;
				margin-bottom: 32px;
			}
			
			.position{
				width: 1200px;
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.lis{
					margin-right: 12px;
					margin-bottom: 16px;
					&:nth-child(3n){
						margin-right: 0;
					}
				}
			}
			
			.look{
				width: 114px;
				height: 36px;
				text-align: center;
				line-height: 36px;
				background-color: rgba(155, 108, 255, 0.10);
				border-radius: 8px;
				color: #9B6CFF;
				font-size: 16px;
				margin: 32px auto 48px;
				cursor: pointer;
				transition: all 0.2s;
				&:hover{
					background-color: rgba(155, 108, 255, 1);
					color: #fff;
				}
				 
			}
		
		    .corporation{
				display: flex;
				align-items: center;
				flex-wrap: wrap;
				.corporationLi{
					background-color: #fff;
					border-radius: 16px;
					overflow: hidden;
					margin-right: 12px;
					margin-bottom: 16px;
					height: 382px;
					&:nth-child(3n){
						margin-right: 0;
					}
					.corporInfo{
						width: 392px;
						height: 88px;
						display: flex;
						align-items: center;
						padding-left: 24px;
						background-color: rgba(81, 161, 144, 0.14);
						box-sizing: border-box;
						.logo{
							flex: 0 0 50px;
							width: 50px;
							height: 50px;
							border-radius: 2px;
							margin-right: 19px;
						}
						.right{
							height: 50px;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							color: #151515;
							.name{
								width: 275px;
								font-size: 18px;
								font-weight: bold;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
							}
							.num{
								font-size: 14px;
							}
						}
					}
				}
			}
		}

	}
</style>